import { render } from "./ConnectionForm.vue?vue&type=template&id=150cb15f"
import script from "./ConnectionForm.vue?vue&type=script&lang=js"
export * from "./ConnectionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__